import {Component, inject} from '@angular/core';
import {TranslatePipe} from '@ngx-translate/core';
import {APP_MODAL_REF} from '../../../constants/modal/app-modal-ref.constant';
import {AppButtonTypeEnum} from '../../../enums/button/app-button-type.enum';
import {ButtonColorEnum} from '../../../enums/button/button-color.enum';
import {AppDialogModal} from '../../../models/modal/dialog/app-dialog-modal.model';
import {ModalService} from '../../../services/modal/modal.service';
import {ButtonComponent} from '../../buttons/button/button.component';
import {AppInputDialogData} from '../../../models/modal/dialog/app-input-dialog-data.model';
import {FormsModule} from '@angular/forms';
import {KeyValue, KeyValuePipe} from '@angular/common';
import {InputDialogInputOption} from '../../../models/input-dialog-options.model';
import {AppDialogMessageDataInputOption} from '../../../models/modal/dialog/app-dialog-message-data-input-option.model';

@Component({
    selector: 'app-input-dialog-modal',
    imports: [
        ButtonComponent,
        TranslatePipe,
        FormsModule,
        KeyValuePipe
    ],
    templateUrl: './input-dialog-modal.component.html',
    styleUrl: './input-dialog-modal.component.css'
})
export class InputDialogModalComponent {
    public readonly modalData: AppInputDialogData;
    protected readonly qaTag: string;
    protected readonly shouldUseFixedDialogWidth: boolean;
    protected indexOrderAsc: (akv: KeyValue<string, InputDialogInputOption>, bkv: KeyValue<string, InputDialogInputOption>) => number;
    protected readonly AppButtonTypeEnum = AppButtonTypeEnum;
    protected readonly ButtonColorEnum = ButtonColorEnum;
    protected readonly messageCssClass: string;
    private readonly modalRef = inject<AppDialogModal<InputDialogModalComponent, AppInputDialogData, Map<string, AppDialogMessageDataInputOption> | undefined>>(APP_MODAL_REF);
    private readonly modalService = inject(ModalService);

    public constructor() {
        this.qaTag = this.modalRef.qaTag;
        this.modalData = this.modalRef.modalData;
        this.shouldUseFixedDialogWidth = !this.modalData.shouldUseFluidDialogWidth;
        this.messageCssClass = this.modalData.shouldPreserveMessageFormatting ? 'modal-dialog-preformatted-message' : 'modal-dialog-message';
        this.indexOrderAsc = (akv: KeyValue<string, InputDialogInputOption>, bkv: KeyValue<string, InputDialogInputOption>): number => {
            if (this.modalData.inputs) {
                const inputKeys = Array.from(this.modalData.inputs.keys());
                const a = inputKeys.indexOf(akv.key);
                const b = inputKeys.indexOf(bkv.key);

                return Math.sign(a - b);
            }

            return 0;
        };
    }

    protected save(): void {
        this.modalService.closeModal(this.modalRef, this.modalData.inputs);
    }

    protected cancel(): void {
        this.modalService.closeModal(this.modalRef);
    }
}
